import { createAction } from 'modules/redux-store';

export const sendPasswordResetEmailAction = {
  success: () => createAction('SEND_PASSWORD_RESET_EMAIL_SUCCESS'),
  error: () => createAction('SEND_PASSWORD_RESET_EMAIL_ERROR'),
};
